<div id="layout" class="f_col">
  <app-view-title fromRoute="legal-acceptance" toRoute="choose-lang" [chooseLangBtn]="api.env.supportedLanguages.length > 1">{{'legal.title' | translate}}</app-view-title>
  <div class="scroll_wrapper resp_wrapper">
    <div class="resp_scroll-wrapper_l resp_c-50">
      <p class="legal-intro" [innerHTML]="'legal.intro' | translate"></p>
      <form [formGroup]="form">
        <div class="legal-doc" *ngFor="let doc of docs; let i = index">
          <app-checkbox-element text="{{doc.key | translate}}" formCtrlName="doc{{i}}" [formGrp]="form"></app-checkbox-element>
          <app-button size="xsm" color="transparent" border="true" (btnClicked)="openPdf(doc.file)">{{'legal.read' | translate}}</app-button>
        </div>
      </form>
      <p class="legal-error" *ngIf="submitted && !form.valid">{{'legal.err.acceptAll' | translate}}</p>
    </div>
  </div>
  <div class="f_align_end mb_20">
    <div class="ml_10 fullWidth">
      <app-button [disabled]="!form.valid" (btnClicked)="continue()" class="fullWidth">{{'global.continue' | translate}}</app-button>
    </div>
  </div>
</div>

<div class="pdf-overlay" *ngIf="openedPdf" (click)="closePdf()">
  <div class="pdf-overlay-inner" (click)="$event.stopPropagation()">
    <ngx-extended-pdf-viewer height="80vh" rotation="0.0" [src]="openedPdf"></ngx-extended-pdf-viewer>
    <div class="mt_20 f_center">
      <app-button size="sm" (btnClicked)="closePdf()">{{'global.close' | translate}}</app-button>
    </div>
  </div>
</div>
